import { profileConstants as pc } from 'srcReact/MyProfile/constant'

const initialState = {
  userType: 'self',
  error: '',
  profileData: {
    loading: false,
    editable: 1,
    user: {
      id: '',
      email: '',
      profile_picture: '',
      is_display_ci: '1',
      cover_picture: '',
      first_name: '',
      last_name: '',
      preferred_pronoun: '',
      personalized_pronoun: '',
      phone_number: '',
      linkedIn_url: '',
      instagram_url: '',
      about_me: '',
      languages: [],
      city: '',
      current_occupation: '',
      originally_from: '',
      children: '',
      favorite_color: '',
      totem_animal: '',
      favorite_sport_team: '',
      experiences: {},
      is_display_pronoun: '',
      is_display_phone: '',
      is_display_email: '',
      interests: {},
      random_matches: [],
      prompts: {
        editable: 0,
        prompts: []
      }
    },
    user_activity: {
      organization_name: '',
      groups_joined: null,
      groups_created: null,
      mixrs_attended: null,
      mixrs_created: null
    },
    groups: [],
    interests: [],
    random_matches: []
  },
  languagePopup: false,
  experiencePopup: false,
  profilePopup: false,
  profileDetailsUpdated: {
    loading: false,
    error: '',
    updated: false
  },
  educationPopup: false,
  imageCropper: false,
  putProfilePicture: {},
  pictureUpdated: false,
  pictureUpdating: false,
  putProfilePopupSuccess: {},
  putProfilePopupFailure: [],
  userId: '',
  userInterests: {
    loading: false,
    updated: false,
    list: [],
    error: null
  },
  userEducation: {
    list: [],
    loading: false,
    error: false,
    updated: false,
    updateType: ''
  },
  userExperience: {
    list: [],
    loading: false,
    error: false,
    updated: false,
    updateType: ''
  },
  userExpertise: {
    list: [],
    loading: false,
    updated: false,
    error: null
  },
  prompts: [],
  promptActions: {
    loading: false,
    id: 0,
    error: '',
    success: false
  }
}

export function myProfile(state = initialState, action) {
  switch (action.type) {
    case pc.SET_USER_TYPE:
      return {
        ...state,
        userType: action.value
      }
    case pc.SET_LANGUAGE_POPUP:
      return {
        ...state,
        languagePopup: action.value
      }
    case pc.SET_EXPERIENCE_POPUP:
      return {
        ...state,
        experiencePopup: action.value
      }
    case pc.SET_USER_ID:
      return {
        ...state,
        userId: action.value
      }
    case pc.SET_PROFILE_POPUP:
      return {
        ...state,
        profilePopup: action.value
      }
    case pc.SET_EDUCATION_POPUP:
      return {
        ...state,
        educationPopup: action.value
      }
    case pc.GET_MY_PROFILE_REQUEST: {
      return {
        ...state,
        profileData: {
          ...state.profileData,
          loading: true
        }
      }
    }
    case pc.GET_MY_PROFILE_SUCCESS:
      return {
        ...state,
        error: '',
        userStatus: action.response.status,
        profileData: {
          ...state.profileData,
          ...action.response,
          loading: false
        },
        userInterests: {
          ...state.userInterests,
          list: action.response.interests
        },
        userExperience: {
          ...state.userExperience,
          list: action.response.user.experiences.experiences
        },
        userEducation: {
          ...state.userEducation,
          list: action.response.user.educations.educations
        },
        userExpertise: {
          ...state.userExpertise,
          list: action.response.user.expertises.expertises
        }
      }
    case pc.GET_MY_PROFILE_FAILURE: {
      return {
        ...state,
        error: action.error,
        userStatus: action.error.includes('deleted') && 'deleted',
        profileData: {
          ...state.profileData,
          editable: 0,
          loading: false
        }
      }
    }
    case pc.PUT_MY_PROFILE_REQUEST: {
      return {
        ...state,
        profileDetailsUpdated: {
          ...state.profileDetailsUpdated,
          loading: true,
          updated: false
        }
      }
    }
    case pc.PUT_MY_PROFILE_SUCCESS: {
      const { key, value } = action.response.updated
      return {
        ...state,
        profileDetailsUpdated: {
          ...state.profileDetailsUpdated,
          loading: false,
          updated: true
        },
        profileData: {
          ...state.profileData,
          user: {
            ...state.profileData.user,
            [key === 'languages_code' ? 'languages' : key]: value
          }
        }
      }
    }
    case pc.PUT_MY_PROFILE_FAILURE: {
      return {
        ...state,
        profileDetailsUpdated: {
          ...state.profileDetailsUpdated,
          loading: false,
          error: action.error,
          updated: false
        }
      }
    }
    case pc.GET_USER_EXPERIENCE_REQUEST: {
      return {
        ...state,
        userExperience: {
          ...state.userExperience,
          loading: true
        }
      }
    }
    case pc.GET_USER_EXPERIENCE_SUCCESS: {
      return {
        ...state,
        userExperience: {
          loading: false,
          list: action.response.experiences,
          error: null
        }
      }
    }
    case pc.GET_USER_EXPERIENCE_FAILURE: {
      return {
        ...state,
        userExperience: {
          error: action.error,
          loading: false,
          list: action.response.experiences
        }
      }
    }
    case pc.ADD_USER_EXPERIENCE_REQUEST:
    case pc.UPDATE_USER_EXPERIENCE_REQUEST:
    case pc.DELETE_USER_EXPERIENCE_REQUEST: {
      return {
        ...state,
        userExperience: {
          ...state.userExperience,
          loading: true,
          updated: false,
          error: null,
          updateType: ''
        }
      }
    }
    case pc.ADD_USER_EXPERIENCE_SUCCESS:
    case pc.UPDATE_USER_EXPERIENCE_SUCCESS:
    case pc.DELETE_USER_EXPERIENCE_SUCCESS: {
      const actionType = action.actionType
      const { id, end_date, organization, role, start_date } = action.response
      const currentList = state.userExperience.list
      let updatedList = []
      if (actionType === 'add') {
        updatedList = [
          {
            id: id,
            organization: organization,
            role: role,
            start_date: start_date,
            end_date: end_date
          },
          ...currentList
        ]
      } else if (actionType === 'update') {
        updatedList = currentList.map((exp) => {
          if (exp.id === id) {
            exp.start_date = start_date
            exp.end_date = end_date
            exp.organization = organization
            exp.role = role
          }
          return exp
        })
      } else if (actionType === 'delete') {
        updatedList = currentList.filter((exp) => exp.id !== id)
      }
      return {
        ...state,
        userExperience: {
          ...state.userExperience,
          list: updatedList,
          loading: false,
          updated: true,
          updateType: actionType
        }
      }
    }
    case pc.ADD_USER_EXPERIENCE_FAILURE:
    case pc.UPDATE_USER_EXPERIENCE_FAILURE:
    case pc.DELETE_USER_EXPERIENCE_FAILURE:
      return {
        ...state,
        userExperience: {
          ...state.userExperience,
          loading: false,
          updated: false,
          error: action.error
        }
      }

    case pc.RESET_EXPERIENCE_POPUP_DATA: {
      return {
        ...state,
        userExperience: {
          ...state.userExperience,
          loading: false,
          updated: false,
          error: null,
          updateType: ''
        }
      }
    }

    case pc.ADD_INTEREST_REQUEST:
    case pc.PUT_INTEREST_REQUEST:
    case pc.REMOVE_INTEREST_REQUEST:
      return {
        ...state,
        userInterests: {
          ...state.userInterests,
          loading: true,
          updated: false,
          error: null
        }
      }
    case pc.PUT_INTEREST_SUCCESS:
    case pc.REMOVE_INTEREST_SUCCESS: {
      return {
        ...state,
        userInterests: {
          ...state.userInterests,
          loading: false,
          updated: true,
          error: null,
          list: action.response.interests
        }
      }
    }
    case pc.ADD_INTEREST_FAILURE:
    case pc.PUT_INTEREST_FAILURE:
    case pc.REMOVE_INTEREST_FAILURE:
      return {
        ...state,
        userInterests: {
          ...state.userInterests,
          loading: false,
          updated: false,
          error: action.error
        }
      }
    case pc.SET_IMAGE_CROPPER:
      return {
        ...state,
        imageCropper: action.value
      }
    case pc.PUT_PROFILE_PICTURE_REQUEST:
      return {
        ...state,
        pictureUpdating: true,
        pictureUpdated: false
      }
    case pc.PUT_PROFILE_PICTURE_SUCCESS:
      return {
        ...state,
        pictureUpdating: false,
        putProfilePicture: action.response,
        pictureUpdated: true
      }
    case pc.PUT_PROFILE_PICTURE_FAILURE:
      return {
        ...state,
        pictureUpdating: false,
        pictureUpdated: false
      }
    case pc.CLEAR_PICTURE_UPDATE_DATA:
      return {
        ...state,
        pictureUpdating: false,
        pictureUpdated: false
      }
    case pc.PUT_PROFILE_POPUP_SUCCESS:
      return {
        ...state,
        putProfilePopupSuccess: action.response,
        profilePopup: false,
        profileData: {
          ...state.profileData,
          user: {
            ...state.profileData.user,
            ...action.response.updated
          }
        }
      }
    case pc.PUT_PROFILE_POPUP_FAILURE:
      return {
        ...state,
        putProfilePopupFailure: action.error
      }
    case pc.GET_USER_EDUCATION_REQUEST: {
      return {
        ...state,
        userEducation: {
          loading: true
        }
      }
    }
    case pc.GET_USER_EDUCATION_SUCCESS: {
      return {
        ...state,
        userEducation: {
          loading: false,
          list: action.response.educations,
          error: null
        }
      }
    }

    case pc.GET_USER_EDUCATION_FAILURE: {
      return {
        ...state,
        userEducation: {
          loading: false,
          list: [],
          error: action.error
        }
      }
    }

    case pc.ADD_USER_EDUCATION_REQUEST:
    case pc.UPDATE_USER_EDUCATION_REQUEST:
    case pc.DELETE_USER_EDUCATION_REQUEST: {
      return {
        ...state,
        userEducation: {
          ...state.userEducation,
          loading: true,
          updated: false,
          error: null,
          updateType: ''
        }
      }
    }
    case pc.ADD_USER_EDUCATION_SUCCESS:
    case pc.UPDATE_USER_EDUCATION_SUCCESS:
    case pc.DELETE_USER_EDUCATION_SUCCESS: {
      const actionType = action.actionType
      const { id, degree, institution, start_date, end_date } = action.response
      const currentList = state.userEducation.list
      let updatedList = []
      if (actionType === 'add') {
        updatedList = [
          {
            id: id,
            institution: institution,
            degree: degree,
            start_date: start_date,
            end_date: end_date
          },
          ...currentList
        ]
      } else if (actionType === 'update') {
        updatedList = currentList.map((edu) => {
          if (edu.id === id) {
            edu.start_date = start_date
            edu.end_date = end_date
            edu.institution = institution
            edu.degree = degree
          }
          return edu
        })
      } else if (actionType === 'delete') {
        updatedList = currentList.filter((edu) => edu.id !== id)
      }
      return {
        ...state,
        userEducation: {
          ...state.userEducation,
          list: updatedList,
          loading: false,
          updated: true,
          updateType: actionType
        }
      }
    }
    case pc.ADD_USER_EDUCATION_FAILURE:
    case pc.UPDATE_USER_EDUCATION_FAILURE:
    case pc.DELETE_USER_EDUCATION_FAILURE:
      return {
        ...state,
        userEducation: {
          ...state.userEducation,
          loading: false,
          updated: false,
          error: action.error
        }
      }

    case pc.RESET_EDUCATION_POPUP_DATA: {
      return {
        ...state,
        userEducation: {
          ...state.userEducation,
          loading: false,
          updated: false,
          error: null,
          updateType: ''
        }
      }
    }

    case pc.UPDATE_EXPERTISE_REQUEST: {
      return {
        ...state,
        userExpertise: {
          ...state.userExpertise,
          loading: true,
          updated: false
        }
      }
    }
    case pc.UPDATE_EXPERTISE_SUCCESS: {
      if (action.response) {
        return {
          ...state,
          userExpertise: {
            ...state.userExpertise,
            loading: false,
            updated: true,
            list: action.response.expertises
          }
        }
      }
    }

    case pc.UPDATE_EXPERTISE_FAILURE: {
      return {
        ...state,
        userExpertise: {
          ...state.userExpertise,
          loading: false,
          updated: false,
          error: action.error
        }
      }
    }

    case pc.SAVE_COVER_PICTURE_REQUEST: {
      return {
        ...state,
        pictureUpdating: true,
        pictureUpdated: false
      }
    }
    case pc.SAVE_COVER_PICTURE_SUCCESS: {
      if (action.response) {
        return {
          ...state,
          pictureUpdating: false,
          pictureUpdated: true,
          profileData: {
            ...state.profileData,
            user: {
              ...state.profileData.user,
              cover_picture: action.response.cover_picture
            }
          }
        }
      }
    }

    case pc.SAVE_COVER_PICTURE_FAILURE: {
      return {
        ...state,
        pictureUpdating: false,
        pictureUpdated: false
      }
    }

    case pc.INITIAL_STATE:
      return {
        ...state,
        putProfilePopupSuccess: {},
        putProfilePopupFailure: []
      }
    case pc.CLEAR_DATA:
      return {
        ...initialState
      }
    case pc.CLEAR_INTEREST_UPDATE: {
      return {
        ...state,
        userInterests: {
          ...state.userInterests,
          loading: false,
          updated: false,
          error: null
        },
        userExpertise: {
          ...state.userExpertise,
          loading: false,
          updated: false,
          error: null
        }
      }
    }
    case pc.ADD_PROMPT_REQUEST:
      return {
        ...state,
        profileData: {
          ...state.profileData,
          user: {
            ...state.profileData.user,
            prompts: {
              ...state.profileData.user.prompts,
              loading: true
            }
          }
        }
      }
    case pc.ADD_PROMPT_SUCCESS:
      return {
        ...state,
        profileData: {
          ...state.profileData,
          user: {
            ...state.profileData.user,
            prompts: {
              ...state.profileData.user.prompts,
              ...action.data,
              loading: false,
              updated: true
            }
          }
        }
      }
    case pc.ADD_PROMPT_FAILURE:
      return {
        ...state,
        profileData: {
          ...state.profileData,
          user: {
            ...state.profileData.user,
            prompts: {
              ...state.profileData.user.prompts,
              loading: false
            }
          }
        }
      }
    case pc.UPDATE_PROMPT_SUCCESS:
      return {
        ...state,
        profileData: {
          ...state.profileData,
          user: {
            ...state.profileData.user,
            prompts: {
              ...state.profileData.user.prompts,
              ...action.data.user_prompts
            }
          }
        }
      }
    case pc.LIKE_OR_DISLIKE_PROMPT_REQUEST:
    case pc.DELETE_PROMPT_REQUEST: {
      return {
        ...state,
        promptActions: { ...state.promptActions, loading: true, id: action.data.prompt_id, success: false }
      }
    }
    case pc.LIKE_OR_DISLIKE_PROMPT_SUCCESS:
    case pc.DELETE_PROMPT_SUCCESS:
      return {
        ...state,
        profileData: {
          ...state.profileData,
          user: {
            ...state.profileData.user,
            prompts: {
              ...state.profileData.user.prompts,
              ...action.data.user_prompts
            }
          }
        },
        promptActions: { ...state.promptActions, loading: false, id: action.prompt_id, success: true }
      }
    case pc.LIKE_OR_DISLIKE_PROMPT_FAILURE:
    case pc.DELETE_PROMPT_FAILURE: {
      return {
        ...state,
        promptActions: { ...state.promptActions, loading: false, success: false }
      }
    }
    case pc.GET_PROMPT_LIST_SUCCESS:
      return {
        ...state,
        prompts: [...action.data.prompts]
      }

    case pc.ADD_INTEREST_SUCCESS: {
      const updatedInterest = state.userInterests?.list?.map((interest) => {
        const found = action.response.find((i) => i.id === interest.id)
        if (found) {
          interest.is_common_with_logged_user = 1
        }
        return interest
      })
      return {
        ...state,
        userInterests: {
          ...state.userInterests,
          loading: false,
          updated: true,
          error: null,
          list: updatedInterest
        }
      }
    }

    default:
      return state
  }
}
